import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router';
import {
    Divider,
    makeStyles,
    Tab,
    Tabs,
    Theme,
    Typography,
} from '@material-ui/core';

import clsx from 'clsx';
import { Page } from '../../components/Page';
import { BackAppBar } from '../../components/BackAppBar';
import { FormGroup } from '../../components/FormGroup';
import { TextField } from '../../components/TextField';
import { TabPanel } from '../../components/TabPanel';
import { useRepairDetail } from '../../hooks/useRepairDetail';
import { DetailList } from './components/DetailList';
import { Block } from '../../components/Block';
import { StageList } from './components/StageList';
import { PageBody } from '../../components/PageBody';
import { DownloadList } from './components/DownloadListList';
import { usePermission } from '../../hooks/usePermission';

type RepairHistoryDetailPageProps = {};

RepairHistoryDetailPage.defaultProps = {};

const useStyles = makeStyles((theme: Theme) => ({
    tabContent: {
        padding: theme.spacing(1),
    },
    step: {
        '& .MuiStepLabel-label': {
            display: 'flex',
            justifyContent: 'space-between',
        },
    },
    hidden: {
        display: 'none',
    },
}));

const TabValue = {
    Content: 'Content',
    Download: 'Download',
};

function RepairHistoryDetailPage(props: RepairHistoryDetailPageProps): React.ReactElement {
    const classes = useStyles();
    const history = useHistory();
    const { name } = useParams<{name: string}>();
    const { repairDetail } = useRepairDetail(name);
    const [selectedTab, setSelectedTab] = useState(TabValue.Content);
    const { permission } = usePermission();

    return (
        <Page>
            <BackAppBar title="此單維修內容" onBackClick={() => history.replace('/repair/history')}>
                <Tabs
                    value={selectedTab}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    onChange={(e, v) => setSelectedTab(v)}
                >
                    <Tab label="維修內容" value={TabValue.Content} />
                    <Tab className={clsx({ [classes.hidden]: permission?.download_file !== true })} label="檔案閱覽" value={TabValue.Download} />
                </Tabs>
            </BackAppBar>
            <PageBody>
                <div className={classes.tabContent}>
                    <TabPanel value={selectedTab} index={TabValue.Content}>
                        <FormGroup>
                            <TextField
                                label="報修單號"
                                value={repairDetail ? repairDetail.name : ''}
                                disabled
                            />
                            <TextField
                                label="產品型號"
                                value={repairDetail ? repairDetail.product_model_id : ''}
                                disabled
                            />
                            <TextField
                                label="產品序號"
                                value={repairDetail ? repairDetail.sn_code_id : ''}
                                disabled
                            />
                            <TextField
                                label="保固狀況"
                                value={repairDetail?.warranty === 'Y' ? '保固內' : '保固外'}
                                disabled
                            />
                            <TextField
                                label="回廠原因"
                                value={repairDetail ? repairDetail.reason_name : ''}
                                disabled
                            />
                        </FormGroup>
                        <Divider />
                        <Block>
                            <DetailList detailList={repairDetail ? repairDetail.detail_list : []} disableDeliveryDate />
                        </Block>
                    </TabPanel>
                    <TabPanel value={selectedTab} index={TabValue.Download}>
                        <Block>
                            <DownloadList fileList={repairDetail ? repairDetail.file_list : []} />
                        </Block>
                    </TabPanel>
                </div>
            </PageBody>
        </Page>
    );
}

export { RepairHistoryDetailPage };
